export enum McbGridColumnAlign {
  LEFT = "left", RIGHT = "right", CENTER = "center"
}
